import {get} from 'lodash';

export const getVariables = (state = {}, variables = {}) => {
  return {
    ...state,
    variables: {
      ...get(state, 'variables', {}),
      ...variables,
    },
  };
};
